import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Advertiser} from '../../../../../models/advertiser';
import {Paginator} from '../../../../../tools/pagination/paginator';
import {TableSorter} from '../../../../../tools/table-sorter/table-sorter';
import {LoaderService} from '../../../../../services/loader/loader.service';
import {DialogService} from '../../../../../services/dialog/dialog.service';
import {SnackbarService} from '../../../../../services/snackbar/snackbar.service';
import {AdvertiserService} from '../../../../../services/advertiser/advertiser.service';
import {ImageService} from '../../../../../services/image/image.service';
import {ConfirmDirective} from '../../../../../directives/confirm/confirm.directive';
import { NgClass, NgOptimizedImage } from '@angular/common';
import {PaginatorComponent} from '../../../../layout/paginator/paginator.component';
import {TableSorterHeaderDirective} from '../../../../../directives/table-sorter/table-sorter-header.directive';
import {TableSorterDirective} from '../../../../../directives/table-sorter/table-sorter.directive';
import {RouterLink} from '@angular/router';
import {Country} from '../../../../../models/country';
import {CountryService} from '../../../../../services/country/country.service';
import {IsGranted} from '../../../../../decorator/is-granted';
import {IsGrantedDirective} from '../../../../../directives/is-granted/is-granted.directive';
import {MetaTitle} from '../../../../../decorator/meta-title';

@Component({
  selector: 'app-advertiser-list',
  imports: [
    ConfirmDirective,
    PaginatorComponent,
    TableSorterHeaderDirective,
    TableSorterDirective,
    RouterLink,
    NgClass,
    NgOptimizedImage,
    IsGrantedDirective
],
  templateUrl: './advertiser-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './advertiser-list.component.scss'
})
@IsGranted(['ADVERTISER_VIEW'])
@MetaTitle('Advertisers')
export class AdvertiserListComponent implements OnInit {
  advertisers: Advertiser[] = [];
  countries: Country[] = [];
  paginator: Paginator = new Paginator();
  tableSorter: TableSorter = new TableSorter('id', 'asc');

  constructor(
    protected countryService: CountryService,
    protected imageService: ImageService,
    private loader: LoaderService,
    private dialog: DialogService,
    private snackbar: SnackbarService,
    private advertiserService: AdvertiserService,
  ) {
  }

  ngOnInit(): void {
    this.refresh();
  }

  refresh(): void {
    this.fetchAll();
  }

  fetchAll(): void {
    this.loader.startLoading();

    this.advertiserService.findAll({}, this.paginator, this.tableSorter).subscribe(advertisers => {
      this.advertisers = advertisers;
      this.loader.stopLoading();
    });
  }

  delete(advertiser: Advertiser): void {
    if (advertiser.id) {
      this.loader.startLoading();
      this.advertiserService.delete(advertiser.id).subscribe(() => {
        this.loader.stopLoading();
        this.snackbar.success('Advertiser has been deleted');
        this.refresh();
      });
    }
  }
}
